/* tile.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./tile.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var styles = {
  root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
  border: "_189ee4h9 _1dqonqa1 _1h6dmuej",
  inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
  nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
var sizeMap = {
  xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
  xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
  small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
  medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
  large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
  xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
var insetSizeMap = {
  xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv",
  xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf",
  small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8",
  medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz",
  large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf",
  xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg"
};
var backgroundColorMap = {
  white: "_bfhku67f",
  black: "_bfhkr3uz",
  'color.background.accent.lime.subtlest': "_bfhkm890",
  'color.background.accent.lime.subtler': "_bfhkz2ec",
  'color.background.accent.lime.subtle': "_bfhkbq5w",
  'color.background.accent.lime.bolder': "_bfhktde4",
  'color.background.accent.red.subtlest': "_bfhk1vk5",
  'color.background.accent.red.subtler': "_bfhk1rtt",
  'color.background.accent.red.subtle': "_bfhkkrt9",
  'color.background.accent.red.bolder': "_bfhkuibq",
  'color.background.accent.orange.subtlest': "_bfhk1g3m",
  'color.background.accent.orange.subtler': "_bfhkf2vu",
  'color.background.accent.orange.subtle': "_bfhk1g6e",
  'color.background.accent.orange.bolder': "_bfhkjgng",
  'color.background.accent.yellow.subtlest': "_bfhk1ozg",
  'color.background.accent.yellow.subtler': "_bfhk3fv2",
  'color.background.accent.yellow.subtle': "_bfhkry5t",
  'color.background.accent.yellow.bolder': "_bfhk1vop",
  'color.background.accent.green.subtlest': "_bfhkn729",
  'color.background.accent.green.subtler': "_bfhk1wnw",
  'color.background.accent.green.subtle': "_bfhk1rsu",
  'color.background.accent.green.bolder': "_bfhk1e5c",
  'color.background.accent.teal.subtlest': "_bfhk7xuz",
  'color.background.accent.teal.subtler': "_bfhk1a17",
  'color.background.accent.teal.subtle': "_bfhktdv8",
  'color.background.accent.teal.bolder': "_bfhk2c8p",
  'color.background.accent.blue.subtlest': "_bfhkavxe",
  'color.background.accent.blue.subtler': "_bfhk4v9p",
  'color.background.accent.blue.subtle': "_bfhk1j89",
  'color.background.accent.blue.bolder': "_bfhkc8cv",
  'color.background.accent.purple.subtlest': "_bfhkp7j4",
  'color.background.accent.purple.subtler': "_bfhk1jkz",
  'color.background.accent.purple.subtle': "_bfhkdh45",
  'color.background.accent.purple.bolder': "_bfhkygwo",
  'color.background.accent.magenta.subtlest': "_bfhk8tvm",
  'color.background.accent.magenta.subtler': "_bfhkv9ra",
  'color.background.accent.magenta.subtle': "_bfhk1mi6",
  'color.background.accent.magenta.bolder': "_bfhkc3uk",
  'color.background.accent.gray.subtlest': "_bfhk11bn",
  'color.background.accent.gray.subtler': "_bfhk1v33",
  'color.background.accent.gray.subtle': "_bfhk1t05",
  'color.background.accent.gray.bolder': "_bfhk1t1b",
  'color.background.inverse.subtle': "_bfhk1vck",
  'color.background.neutral': "_bfhkm7j4",
  'color.background.neutral.bold': "_bfhkcdhy",
  'color.background.brand.subtlest': "_bfhk3wxy",
  'color.background.brand.bold': "_bfhkb29m",
  'color.background.brand.boldest': "_bfhk15mt",
  'color.background.danger': "_bfhk1gly",
  'color.background.danger.bold': "_bfhkybec",
  'color.background.warning': "_bfhk1tzq",
  'color.background.warning.bold': "_bfhk190i",
  'color.background.success': "_bfhkmv6i",
  'color.background.success.bold': "_bfhk8emd",
  'color.background.discovery': "_bfhk1nvp",
  'color.background.discovery.bold': "_bfhk1lri",
  'color.background.information': "_bfhk33gi",
  'color.background.information.bold': "_bfhk14wj"
};

/**
 * __Tile__
 *
 * A tile is a rounded square that takes an asset (Image, Icon, Logo) and represents a noun.
 *
 */
export default function Tile(props) {
  var children = props.children,
    label = props.label,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    backgroundColor = props.backgroundColor,
    hasBorder = props.hasBorder,
    _props$isInset = props.isInset,
    isInset = _props$isInset === void 0 ? true : _props$isInset,
    testId = props.testId;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": testId,
    "aria-label": label !== '' ? label : undefined,
    role: label !== '' ? 'img' : undefined,
    className: ax([styles.root, sizeMap[size], isInset ? styles.inset : styles.nonInset, isInset && insetSizeMap[size], backgroundColorMap[backgroundColor || 'color.background.neutral'], hasBorder && styles.border])
  }, children);
}